import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { MapPin } from 'lucide-react';

const Projects = () => {
  const projects = [
    {
      image: 'https://images.unsplash.com/photo-1624397640148-949b1732bb0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHJvb2Z0b3AlMjBwYW5lbHN8ZW58MHx8fHwxNzYwNDYxMjc2fDA&ixlib=rb-4.1.0&q=85',
      title: '10 kW Residential Installation',
      location: 'Guwahati, Assam',
      type: 'Residential'
    },
    {
      image: 'https://images.pexels.com/photos/29206495/pexels-photo-29206495.jpeg',
      title: '50 kW Commercial Solar Plant',
      location: 'Jorhat, Assam',
      type: 'Commercial'
    },
    {
      image: 'https://images.pexels.com/photos/9875408/pexels-photo-9875408.jpeg',
      title: '15 kW Rooftop System',
      location: 'Golaghat, Assam',
      type: 'Residential'
    },
    {
      image: 'https://images.unsplash.com/photo-1668097613572-40b7c11c8727?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxzb2xhciUyMGluc3RhbGxhdGlvbnxlbnwwfHx8fDE3NjA0NjEyODJ8MA&ixlib=rb-4.1.0&q=85',
      title: '100 kW Industrial Solar Installation',
      location: 'Guwahati, Assam',
      type: 'Industrial'
    },
    {
      image: 'https://images.unsplash.com/photo-1660330589505-9a433a742a7b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxzb2xhciUyMGluc3RhbGxhdGlvbnxlbnwwfHx8fDE3NjA0NjEyODJ8MA&ixlib=rb-4.1.0&q=85',
      title: '8 kW Home Solar System',
      location: 'Sivasagar Assam',
      type: 'Residential'
    },
    {
      image: 'https://images.unsplash.com/photo-1542336391-ae2936d8efe4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxzb2xhciUyMGluc3RhbGxhdGlvbnxlbnwwfHx8fDE3NjA0NjEyODJ8MA&ixlib=rb-4.1.0&q=85',
      title: '25 kW School Solar Project',
      location: 'Dibrugarh, Assam',
      type: 'Institutional'
    },
    {
      image: 'https://images.pexels.com/photos/8853502/pexels-photo-8853502.jpeg',
      title: '12 kW Villa Installation',
      location: 'Shillong Meghalaya',
      type: 'Residential'
    },
    {
      image: 'https://images.unsplash.com/photo-1559302504-64aae6ca6b6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxzb2xhciUyMHJvb2Z0b3AlMjBwYW5lbHN8ZW58MHx8fHwxNzYwNDYxMjc2fDA&ixlib=rb-4.1.0&q=85',
      title: '75 kW Factory Solar System',
      location: 'Nagaon, Assam',
      type: 'Industrial'
    },
    {
      image: 'https://images.unsplash.com/photo-1624397640148-949b1732bb0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHJvb2Z0b3AlMjBwYW5lbHN8ZW58MHx8fHwxNzYwNDYxMjc2fDA&ixlib=rb-4.1.0&q=85',
      title: '20 kW Apartment Complex',
      location: 'Tinisukia, Assam',
      type: 'Residential'
    }
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-20 px-6 bg-gradient-to-br from-[#0D47A1] to-[#1565C0] text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl font-bold mb-6">Our Projects</h1>
          <p className="text-xl text-gray-100 leading-relaxed">
            Explore our portfolio of successful solar installations across India
          </p>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-12 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-[#FFC107] mb-2">200+</div>
              <div className="text-gray-700 font-medium">Projects Completed</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#4CAF50] mb-2">1 MW+</div>
              <div className="text-gray-700 font-medium">Total Capacity Installed</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#0D47A1] mb-2">10+</div>
              <div className="text-gray-700 font-medium">Cities Covered</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#FFC107] mb-2">100%</div>
              <div className="text-gray-700 font-medium">On-Time Completion</div>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Gallery */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold text-center text-[#0D47A1] mb-4">Featured Projects</h2>
          <p className="text-center text-gray-600 mb-12 text-lg">Trusted by homes and businesses across India</p>
          
          <div className="grid md:grid-cols-3 gap-8">
            {projects.map((project, index) => (
              <Card 
                key={index} 
                className="overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-none bg-white"
              >
                <CardContent className="p-0">
                  <div className="relative h-64 overflow-hidden">
                    <img 
                      src={project.image} 
                      alt={project.title} 
                      className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute top-4 right-4">
                      <span className="bg-[#FFC107] text-black px-3 py-1 rounded-full text-sm font-semibold">
                        {project.type}
                      </span>
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="font-bold text-xl text-[#0D47A1] mb-3">{project.title}</h3>
                    <div className="flex items-center text-gray-600">
                      <MapPin className="w-4 h-4 mr-2 text-[#4CAF50]" />
                      <span>{project.location}</span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-[#0D47A1] mb-6">Want to See Your Project Here?</h2>
          <p className="text-xl text-gray-700 mb-8">
            Join hundreds of satisfied customers who have made the switch to solar energy
          </p>
          <a href="/contact">
            <button className="bg-[#4CAF50] hover:bg-[#66BB6A] text-white font-semibold text-lg px-8 py-4 rounded-lg transition-all duration-300 hover:scale-105 hover:shadow-xl">
              Start Your Solar Project
            </button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default Projects;